"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAreaEmpty = exports.fillRoom = exports.createRoom = exports.tilemapCollectFreeSpots = exports.collectFreeSpots = exports.isClear8 = exports.dirs8 = exports.isEntityAt = exports.flipAxis = void 0;
var diveObjects_sidecar_1 = require("@dive/entities/diveObjects-sidecar");
var diveCrew_sidecar_1 = require("@voyage/crew/diveCrew-sidecar");
var diveTileData_1 = require("../../tilemap/diveTileData");
var diveTileData_sidecar_1 = require("../../tilemap/diveTileData-sidecar");
var diveTilemap_sidecar_1 = require("../../tilemap/diveTilemap-sidecar");
var diveTilemapPart_sidecar_1 = require("../../tilemap/diveTilemapPart-sidecar");
var flipAxis = function (axis) {
    if (axis === 'x') {
        return 'y';
    }
    return 'x';
};
exports.flipAxis = flipAxis;
var isEntityAt = function (i, j) {
    var obj = diveObjects_sidecar_1.diveObjects.getAtIJ(i, j);
    if (obj) {
        return true;
    }
    var mon = diveCrew_sidecar_1.diveCrew.getAtIJ(i, j);
    if (mon) {
        return true;
    }
    false;
};
exports.isEntityAt = isEntityAt;
exports.dirs8 = [
    [-1, 0],
    [1, 0],
    [0, -1],
    [0, 1],
    [-1, -1],
    [-1, 1],
    [1, -1],
    [1, 1],
];
var isClear8 = function (i, j) {
    for (var dIdx = 0; dIdx < exports.dirs8.length; dIdx++) {
        var d = exports.dirs8[dIdx];
        // TODO: check for objects like barrels, monsters, etc.
        var ti = i + d[0];
        var tj = j + d[1];
        var gs2 = diveTilemap_sidecar_1.diveTilemap.getSafe(ti, tj);
        if (!gs2 || gs2.tile1.type !== diveTileData_1.EDiveTile.Floor) {
            return false;
        }
        if (exports.isEntityAt(ti, tj)) {
            // console.log(
            //   'entity at',
            //   i,
            //   j,
            //   ti,
            //   tj,
            //   d[0],
            //   d[1],
            //   dirs8.length,
            //   dIdx,
            //   'isClear8',
            // )
            return false;
        }
    }
    return true;
};
exports.isClear8 = isClear8;
function collectFreeSpots(info) {
    var sizeX = info.sizeX, sizeY = info.sizeY;
    // Collect all free spots
    var freeSpots = [];
    for (var j = 0; j < sizeY; j++) {
        for (var i = 0; i < sizeX; i++) {
            var gs = diveTilemap_sidecar_1.diveTilemap.getUnsafe(i, j);
            if (gs.tile1.type === diveTileData_1.EDiveTile.Floor) {
                if (exports.isEntityAt(i, j)) {
                    continue;
                }
                freeSpots.push(gs);
            }
        }
    }
    info.openFloors = freeSpots;
}
exports.collectFreeSpots = collectFreeSpots;
// TODO: move elsewhere?
function tilemapCollectFreeSpots() {
    var _a = __read(diveTilemap_sidecar_1.diveTilemap.getSize(), 2), width = _a[0], height = _a[1];
    // Collect all free spots
    var freeSpots = [];
    for (var j = 0; j < width; j++) {
        for (var i = 0; i < height; i++) {
            var gs = diveTilemap_sidecar_1.diveTilemap.getUnsafe(i, j);
            if (gs.tile1.type === diveTileData_1.EDiveTile.Floor) {
                if (!exports.isEntityAt(i, j)) {
                    freeSpots.push(gs);
                }
            }
        }
    }
    return freeSpots;
}
exports.tilemapCollectFreeSpots = tilemapCollectFreeSpots;
function createRoom(x, y, w, h) {
    return {
        x: x,
        y: y,
        w: w,
        h: h,
        isStartRoom: false,
        isCenterHallway: false,
        isProcessed: false,
    };
}
exports.createRoom = createRoom;
function fillRoom(info, x, y, w, h, t, cb) {
    var r = createRoom(x, y, w, h);
    info.rooms.push(r);
    // Fill room with tile
    var td = diveTileData_sidecar_1.diveTileData.get(t);
    for (var j = 0; j < r.h; j++) {
        for (var i = 0; i < r.w; i++) {
            var gs = diveTilemap_sidecar_1.diveTilemap.getUnsafe(r.x + i, r.y + j);
            diveTilemapPart_sidecar_1.diveTilemapPart.setTile(gs, td);
            if (cb) {
                cb(gs);
            }
            else {
                gs.isCentralHallway = false;
                gs.isRoom = true;
            }
        }
    }
    return r;
}
exports.fillRoom = fillRoom;
function isAreaEmpty(x, y, w, h, tEmpty, allowEdges) {
    for (var j = 0; j < h; j++) {
        for (var i = 0; i < w; i++) {
            var xs = x + i;
            var ys = y + j;
            var gs = diveTilemap_sidecar_1.diveTilemap.getSafe(xs, ys);
            if (!gs || gs.tile1.type !== tEmpty) {
                return false;
            }
            // Check if this is an edge
            if (!allowEdges) {
                if (xs === 0 ||
                    ys === 0 ||
                    xs === diveTilemap_sidecar_1.diveTilemap.get().width - 1 ||
                    ys === diveTilemap_sidecar_1.diveTilemap.get().height - 1) {
                    return false;
                }
            }
        }
    }
    return true;
}
exports.isAreaEmpty = isAreaEmpty;
